import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { X, MessageCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { LOGO_URL } from "../config/constants";

const AboutModal = ({ onClose }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  
  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="font-manrope font-bold text-xl">{t("about")}</h2>
          <button onClick={onClose}><X size={24} /></button>
        </div>
        
        <div className="text-center mb-6">
          <img src={LOGO_URL} alt="Lite Gold" className="w-24 h-24 mx-auto rounded-full mb-4" />
          <h3 className="text-2xl font-bold text-gold-gradient">Lite Gold (LTG)</h3>
        </div>
        
        <p className="text-muted-foreground text-sm mb-6">{t("aboutText")}</p>
        
        <div className="border-t border-border pt-4 mb-4">
          <p className="text-primary font-semibold mb-2">{t("companyAddress")}:</p>
          <p className="text-muted-foreground text-sm">
            Lite Gold (LTG)<br />
            1209 Delaware Avenue, Suite 1350<br />
            Wilmington, Delaware 19806<br />
            United States
          </p>
        </div>

        <button 
          onClick={() => { onClose(); navigate("/support"); }}
          className="w-full py-3 bg-gradient-to-r from-cyan-600 to-blue-600 rounded-xl font-bold flex items-center justify-center gap-2 mb-4"
        >
          <MessageCircle size={20} /> {t("supportChat")}
        </button>
        
        <div className="border-t border-border pt-4 text-center">
          <p className="text-muted-foreground text-sm">{t("version")}</p>
        </div>
      </div>
    </>
  );
};

export default AboutModal;
